// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"cardTitle___2kTZx"};